import { render, staticRenderFns } from "./ServiceProviderRequirement.vue?vue&type=template&id=5ed78ef4&"
import script from "./ServiceProviderRequirement.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderRequirement.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderRequirement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports